// src/pages/PathManagePatient/CompletedTests.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
  Paper,
  Button,
  IconButton,
} from "@mui/material";
import { getCompletedTests } from "../../services/pathLabTestReportService";
import Refresh from "@mui/icons-material/Refresh"; // Import refresh icon
import Calendar from "../calendar/calendar"; // Import the Calendar component

const CompletedTests = () => {
  const [completedTests, setCompletedTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openCalendar, setOpenCalendar] = useState(false); // State for Calendar
  const [labTestInfo, setLabTestInfo] = useState({}); // State for lab test info

  useEffect(() => {
    fetchCompletedTests();
  }, []);

  const fetchCompletedTests = async () => {
    try {
      const data = await getCompletedTests(); // Fetch completed tests from the service
      // setCompletedTests(data);
      const sorted = [...(data || [])].sort((a, b) => new Date(b.reportDate) - new Date(a.reportDate));
      setCompletedTests(sorted);
    } catch (error) {
      console.error("Error fetching completed tests:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (test) => {
    setLabTestInfo({
      patientId: test.patientId,
      patientName: test.patientName,
      doctorId: test.doctorId,
      doctorName: test.doctorName,
    });
    setOpenCalendar(true); // Open the Calendar
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Completed Tests</Typography>
          <IconButton onClick={fetchCompletedTests}>
            <Refresh />
          </IconButton>
        </Grid>
        {completedTests.length > 0 ? (
          completedTests.map((test) => (
            <Grid item xs={12} sm={6} md={4} key={test.reportId}>
              <Paper elevation={3} sx={{ p: 2 }}>
                <Typography variant="body1">Patient: {test.patientName}</Typography>
                <Typography variant="body1">Doctor: {test.doctorName}</Typography> {/* Display Doctor's Name */}
                <Typography variant="body2">Test Name: {test.testName}</Typography>
                <Typography variant="body2">Result: {test.result}</Typography>
                {/* <Typography variant="body2">Report ID: {test.reportId}</Typography> */}
                <Typography variant="body2">Report Date: {new Date(test.reportDate).toLocaleDateString()}</Typography>
                <Box display="flex" justifyContent="space-between" marginTop={1}>
                  <Button variant="contained" color="primary" onClick={() => handleViewDetails(test)}>View Details</Button>
                </Box>
              </Paper>
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Typography>No completed tests available.</Typography>
          </Grid>
        )}
      </Grid>
      
      {/* Calendar Component */}
      <Calendar
        open={openCalendar}
        onClose={() => {
          setOpenCalendar(false);
          setLabTestInfo(null);
        }}
        appointment={labTestInfo} // Pass the lab test info to the Calendar
      />

    </Box>
  );
};

export default CompletedTests;
